export const findAncestor = (
  element: Element | null,
  selector: string,
  child: Element | null = null,
): Element | null => {
  if (!element?.querySelector) {
    return null;
  }

  const founds = element.querySelectorAll(selector);
  const childIndex = Array.from(founds).findIndex((found) => found?.contains(child));

  return (
    (childIndex > -1 ? founds[childIndex] : false) ||
    findAncestor(element.parentNode as Element, selector, element)
  );
};
